import { clsx } from 'clsx'

import type { PageGroup } from '@st/sdk'

export function SigningSectionsNav({
  id,
  pageGroups,
  isOpen,
  onClose,
  onSelect
}: {
  id: string
  pageGroups: PageGroup[]
  isOpen: boolean
  onClose: () => void
  onSelect: (group: PageGroup) => void
}) {
  if (pageGroups.length == 0) return null

  // Selection clears mobile state; desktop ignores isOpen and stays beside the PDF.
  return (
    <>
      {isOpen && (
        <button
          type="button"
          aria-label="Close sections"
          className="absolute inset-0 z-20 bg-black/30 lg:hidden"
          onClick={onClose}
        />
      )}
      <nav
        id={id}
        aria-label="Document sections"
        className={clsx(
          'absolute inset-x-0 top-0 z-20 max-h-[70%] w-full overflow-auto border-b border-gray-200 bg-white p-3 shadow-lg lg:static lg:block lg:max-h-none lg:w-60 lg:shrink-0 lg:border-b-0 lg:border-r lg:shadow-none',
          !isOpen && 'hidden'
        )}
      >
        <div className="mb-2 hidden min-h-11 items-center px-2 text-sm font-semibold text-gray-700 lg:flex">
          Sections
        </div>
        <ul className="space-y-1">
          {pageGroups.map((group) => (
            <li key={group.pageRange.first}>
              <button
                type="button"
                className="min-h-11 w-full rounded px-2 py-2 text-left text-sm font-medium text-gray-700 hover:bg-gray-100"
                onClick={() => {
                  onSelect(group)
                  onClose()
                }}
              >
                {group.title}
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </>
  )
}
